import { render, staticRenderFns } from "./QuestionDetailsTab.vue?vue&type=template&id=248fbed6&scoped=true&"
import script from "./QuestionDetailsTab.vue?vue&type=script&lang=js&"
export * from "./QuestionDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248fbed6",
  null
  
)

export default component.exports